export class Colors {
  static brandBase = '#0A0A47';
  static brandWhite = '#ffffff';
  static background = '#ffffff';
  static neutralMedium = '#7E7E9E';
  static neutralOff = '#F3F3F6';
  static neutralDark = '#5C5C84';
  static neutralDarkAlpha = '#6c6c91';
  static neutralDarker = '#3B3B6C';
  static neutralLight = '#B9B9CA';
  static neutralLightAlpha = '#0A0A4725';
  static neutralLighter = '#DCDCE4';
  static neutralLighterAlpha = '#0A0A4710';
  static transparent = 'transparent';
  static primary = '#13138a';
  static primaryActive = '#1A1AB7';
  static danger = '#F24242';
  // todo: error doesn't exist, it should be called "invalid"
  static error = '#F24242';
  static success = '#22C580';
  static linkActive = '#07A7FF';
  static warning = '#FF8839';
  static informativeBannerBorder = '#CCE9F9';
  static informativeBannerBackground = '#F5FBFE';
  static successBannerBorder = '#C8F1DF';
  static successBannerBackground = '#F4FCF9';
  static warningBannerBorder = '#FFE1CE';
  static warningBannerBackground = '#FFF9F5';
  static dangerBannerBorder = '#FCD0D0';
  static dangerBannerBackground = '#FEF6F6';
}
